import ListingCardThumbnail from './ListingCardThumbnail.component';

export default ListingCardThumbnail;
